import React from 'react';
import { motion } from 'framer-motion';
import { Layers, Database, Brain, Cloud } from 'lucide-react';

const TechCard = ({ title, description, icon: Icon, tags, color, className }) => (
  <motion.div 
    whileHover={{ y: -5 }}
    className={`relative p-6 rounded-[32px] bg-[#0F172A] border border-white/5 overflow-hidden flex flex-col justify-between ${className}`}
  >
    {/* Efecto de resplandor sutil en la esquina */}
    <div className={`absolute -top-12 -right-12 w-24 h-24 blur-[60px] opacity-20 bg-${color}-500`} />
    
    <div>
      <div className={`w-12 h-12 rounded-2xl bg-${color}-500/10 flex items-center justify-center mb-6 border border-${color}-500/20`}>
        <Icon size={24} className={`text-${color}-400`} />
      </div>
      
      <h3 className="text-2xl font-black text-white mb-3 tracking-tighter uppercase italic">
        {title}
      </h3>
      <p className="text-slate-400 text-sm font-medium leading-relaxed mb-8">
        {description}
      </p>
    </div>

    
    <div className="flex flex-wrap gap-2">
      {tags.map((tag) => (
        <span 
          key={tag}
          className="px-3 py-1.5 rounded-xl bg-white/5 border border-white/5 text-[10px] font-black text-slate-300 uppercase tracking-widest whitespace-nowrap"
        >
          {tag}
        </span>
      ))}
    </div>
  </motion.div>
);

const LearningGrid = () => {
  return (
    <section className="py-24 px-6 max-w-7xl mx-auto">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-6 auto-rows-auto">
        
        
        <TechCard 
          title="Frontend Experience"
          description="Crea interfaces de usuario ultra-fluidas y reactivas utilizando las herramientas líderes de la industria."
          icon={Layers}
          color="blue"
          tags={['React 19', 'Next.js 15', 'Tailwind CSS', 'Framer Motion', 'TypeScript']}
          className="md:col-span-7 h-full"
        />

        
        <TechCard 
          title="Backend Infrastructure"
          description="Sistemas robustos y escalables para soportar millones de usuarios."
          icon={Database}
          color="emerald"
          tags={['Node.js', 'PostgreSQL', 'Redis', 'Docker', 'Prisma']}
          className="md:col-span-5 h-full"
        />

        
        <TechCard 
          title="AI Systems"
          description="Integración de modelos inteligentes en aplicaciones modernas."
          icon={Brain}
          color="purple"
          tags={['Python', 'OpenAI', 'Langchain', 'PyTorch']}
          className="md:col-span-5 h-full"
        />

        <TechCard 
          title="Cloud Deploy"
          description="Infraestructura global optimizada para el rendimiento."
          icon={Cloud}
          color="cyan"
          tags={['AWS', 'Vercel', 'Terraform', 'CI/CD']}
          className="md:col-span-7 h-full"
        />

      </div>
    </section>
  );
};

export default LearningGrid;